const deburrObject = (o: TJSONAPIResponseObject): any => {
  const obj = {
    ...o,
    ...o.attributes,
    ...o.relationships,
  };

  return obj;
};

const normalizeOne = (r: any) => {
  const R = deburrObject(r);

  return Object.keys(R).reduce((a: any, m: string) => {
    return {
      ...a,
      [m]: R[m]
        ? Array.isArray(R[m])
          ? R[m].map(deburrObject)
          : typeof R[m] === 'object'
            ? deburrObject(R[m])
            : R[m]
        : undefined,
    };
  }, {});
};

export {
  deburrObject,
  normalizeOne,
};
